module.exports = __webpack_public_path__ + "img/GoTo_RGB_Black_Yellow.4743b7ac.png";